<section class="pt-2 ">
  <div class="container-style">
    <div class="row align-items-center pb-2">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>
          {{'Detalle Interfaz Factura Electrónica' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <app-custom-button [disabled]="disabledButton" [label]="'Generar Pdf'" [severity]="'primary'" [width]="'7rem'"
            (onClick)="openDocumentsSelectionModal ()"></app-custom-button>
          <app-custom-modal #documentsSelection [label]="'Seleccionar'" [header]="'Generar Pdfs'"
            [children]="componentTableSelection" [inputs$]="inputsForDocumentsSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>

          <app-custom-button [label]="'Enviar Correo'" [severity]="'primary'" [disabled]="disabledButton"
            [width]="'7rem'" (onClick)="openSendEmail()"></app-custom-button>
          <app-custom-modal #sendEmail [header]="'Enviar Correo'" [children]="componentSendEmail" [closable]="true"
            [width]="'60vw'" [inputs$]="inputsForSendEmail$" [output$]="outputForSendEmail$" hidden></app-custom-modal>
        </div>
      </div>
    </div>
    <div class="row mb-2" *ngIf="visibleProgressBar">
      <p class="mb-2"><b class="style-text">Generando pdf...</b></p>
      <app-custom-progress-bar [show]="true" [heightProgress]="'0.8rem'"></app-custom-progress-bar>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [rowClass]="rejectedDianRowClass" (onRecoverData)="getElectronicInvoiceInterfaceDetailById(false)" (onPageChange)="onPageChange($event,false)"
        (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>